import { useSelector } from "react-redux";
// @ts-expect-error: ignoring as it is existing js file
import { userSelector } from "@/store/slices/userSlice";
import type { UserSlice, UserState } from "@/store/slices/types/userSlice";
import { APPLICATION_DOWNLOAD_TYPE, defaultCreditScoreValues, getApplicationTypeList } from "@/constants";

const useAccessAppComponent = () => {
  const userData = useSelector<UserSlice, UserState>(userSelector);

  // Note: When we add any new key we need to add to server as well to make consistency
  const defaultAccessComponents = {
    user: {
      isShowTopLenders: false,
    },
    application: {
      asset: {
        isDefaultManualAssets: false,
        isVehicleSearch: true,
        isPPSRSearch: true,
        isGlassesGuideSearchable: true,
        isInsuranceQuote: true,
      },
      loanDetails: {
        isOriginationFeeEnabled: true,
      },
      entity: {
        isAsicExtractEnabled: true,
        isAsicExtractPPSREnabled: true,
        isEquifaxCommercialReportEnabled: true,
        isEquifaxScoredCommercialReportEnabled: true,
        isEntityCreditScoreEnabled: true,
        isEntityCreditReportEnabled: true,
      },
      customer: {
        isBankStatementsEnabled: true,
        isIdVerificationEnabled: true,
        isEquifaxConsumerReportEnabled: true,
        isEmploymentIncomeVerificationEnabled: true,
        defaultCreditScoreTypes: defaultCreditScoreValues,
        allowedBankStatementDays: [90, 180, 270, 365],
        isLiabilitiesBufferEnabled: false,
        liabilitiesBuffer: 1, // This is default to 1 because it's use for multiplication
        isIncomeShadingEnabled: false,
        incomeShading: 100, // This is in percentage
        uploadBankStatementsEnabled: false,
        isIllionDocIdFieldEnabled: false, // This is for bank statement
      },
      type: getApplicationTypeList,
      defaultApplicationDownloadType: APPLICATION_DOWNLOAD_TYPE.PDF,
    },
    organisation: {
      isShowTopLenders: false,
      isOrgComplaintsEmail: true,
      isAclComplaintsEmail: true,
      isAclComplaintsPhoneNumber: true,
      isAclComplaintsTelephoneNumber: true,
    },
  };

  const accessComponents = userData?.platformUIComponentAccess || defaultAccessComponents;

  return {
    accessComponents,
  };
};

export { useAccessAppComponent };
